export default __webpack_public_path__ + "b4e71f6375ce977be59ea6375a1b58a1.svg";